import { useEffect, useState } from "react";
import envConfig from "@/config/envConfig";

/**
 * Custom hook to track loading duration and show timeout message
 * @param {boolean} isLoading - Current loading state
 * @param {number} timeout - Timeout duration in milliseconds (default from .env VITE_LOADING_TIMEOUT_MS)
 * @returns {boolean} showTimeoutMessage - Whether to show the timeout message
 */
export const useLoadingTimeout = (isLoading, timeout = envConfig.LOADING_TIMEOUT_MS) => {
  const [showTimeoutMessage, setShowTimeoutMessage] = useState(false);

  useEffect(() => {
    let timeoutId;

    if (isLoading) {
      // Set timeout to show message after specified duration
      timeoutId = setTimeout(() => {
        setShowTimeoutMessage(true);
      }, timeout);
    } else {
      // Reset when loading completes
      setShowTimeoutMessage(false);
    }

    // Cleanup timeout on unmount or when loading changes
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isLoading, timeout]);

  return showTimeoutMessage;
};
